/** Creative Samurai course fee in BDT (numeric, no currency symbol). */
export const CREATIVE_SAMURAI_COURSE_FEE = 4400;

/** Original list price before promotional discount. */
export const CREATIVE_SAMURAI_ORIGINAL_FEE = 5500;

/** Promotional discount percentage (original → course fee). */
export const CREATIVE_SAMURAI_DISCOUNT_PERCENT = 20;

export const formatCourseFee = (amount) =>
  `৳ ${Number(amount).toLocaleString('en-BD')}`;
